<template>
    <transition name="slide-fade">
        <div class="alert-point-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content-wrapper p-3 relative ">
                    <div class="absolute right-6 top-3 cursor-pointer" @click="clickOk()">
                        <img class="w-4" src="@/assets/icon/ic-close.png" />
                    </div>
                    <div class="w-full text-center -mt-12">
                        <img class="w-20 m-auto" src="@/assets/icon/ic-success.png" />
                    </div>
                    <div class="text-center text-tc-blue-2 text-24 pt-3">{{title}}</div>
                    <div class="text-center text-tc-gray-3 text-20 pt-3">{{message}}</div>
                    <div v-if="btnOk" class="w-full p-5">
                        <BlueBtn @click="clickOk()">{{ btnOk }}</BlueBtn>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BlueBtn from '@/components/Button/BlueBtn.vue'
export default {
    name: "AlertPointModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components:{
        BlueBtn
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            point: 0,
            type: 'point',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.point = config.point;
            this.type = config.type;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickGototip: function () {
            window.location.href = 'https://tipsociety.dhipaya.co.th/Accounts/Login'
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .alert-point-modal {
        @extend %modal;
        overflow: unset;

        @include mobile {
            top: auto;
        }
        .modal-content {
            width: 400px;
            overflow: unset;
            .content-wrapper {
                border-radius: 25px;
                @include mobile {
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;

                    width: 100%;
                }
            }
            @include mobile {
                width: 100%;
            }
        }
    }
</style>
